'use client';

import { useState, createContext } from 'react';

import { type I18n, createI18nContext, translate } from '@openclassrooms/translations/i18nService';

export interface I18nContextType {
  i18n: I18n;
  translate: typeof translate;
}

export const I18nContext = createContext<I18nContextType | null>(null);

export function I18nProvider({
  children,
  locale,
  messages,
}: Readonly<{
  children: React.ReactNode;
  locale: string;
  messages: Record<string, string>;
}>) {
  const [i18nContext] = useState(() => {
    const [lang, country] = locale.split('-');

    return createI18nContext({
      country,
      locale,
      lang,
      messages,
    });
  });

  return <I18nContext.Provider value={i18nContext}>{children}</I18nContext.Provider>;
}
